import angular from 'angular';
import QrCreator from 'qr-creator';

angular
  .module('cloudX')
  .controller('Disable2FADialog', [
    '$element',
    'resourceFactorySvc',
    'dataCache',
    'flySvc',
    'close',
    Disable2FADialog,
  ]);

function Disable2FADialog($element, resourceFactorySvc, dataCache, flySvc, close) {
  var vm = this;
  vm.data = {
    password: undefined,
  };

  vm.save = function() {
    vm.saving = true;
    resourceFactorySvc.get('user').disable2FA(
      null,
      vm.data,
      function() {
        vm.saving = false;
        flySvc.success('msg2FADisabled');
        close(true, 500);
        $element.modal('hide');
      },
      function(error) {
        vm.saving = false;
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
